export type RequestTypeEnum = 'POWER_OUTAGE' | 'FIELD_WORK' | 'MEDICAL_APPOINTMENT' | 'UNEXPECTED_EVENT' | 'OTHER';

export const RequestTypeEnumValues = {
    PowerOutage: 'POWER_OUTAGE' as RequestTypeEnum,
    FieldWork: 'FIELD_WORK' as RequestTypeEnum,
    MedicalAppointment: 'MEDICAL_APPOINTMENT' as RequestTypeEnum,
    UnexpectedEvent: 'UNEXPECTED_EVENT' as RequestTypeEnum,
    Other: 'OTHER' as RequestTypeEnum,
};
